import React, { Component } from 'react';
import { connect } from 'react-redux';
import Module from '../../modules/circle/new';

class FormOshikatsuCirclesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCircleId: null,
      openCircleIdForModal: null,
    };
    this.handleClickLater = this.handleClickLater.bind(this);
    this.onClickBack = this.onClickBack.bind(this);
    this.onClickNext = this.onClickNext.bind(this);
    this.onClickParentCircle = this.onClickParentCircle.bind(this);
    this.selectChildCircle = this.selectChildCircle.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  handleClickLater() {
    this.props.changePage('2');
  }
  onClickBack(e) {
    e.preventDefault();
    this.props.changePage(e.target.value);
  }

  onClickNext() {
    const circle = { ...this.props.circle };
    const serviceIdNum = Number(this.props.selectedServiceIds[0]); 
    if (!this.state.selectedCircleId) {
      alert('サークルを選択してください');
      return;
    }
    this.props.createRelation({
      parent_id: this.state.selectedCircleId,
      child_id: circle.id,
    });
    // 紐づけ
    this.props.createOshikatsuGenre(circle.id, String(serviceIdNum));
    circle.selected_oshikatsu_circle_id = this.state.selectedCircleId;
    this.props.updateCircle(circle);
    this.props.changePage('2');
  }

  onClickParentCircle(circleId) {
    this.setState({ openCircleIdForModal: circleId });
  }

  selectChildCircle(circleId) {
    this.setState((prev) => ({
      selectedCircleId: prev.selectedCircleId === circleId ? null : circleId,
    }));
  }
  closeModal() {
    this.setState({ openCircleIdForModal: null });
  }

  componentDidMount() {
    const circleId = this.props.circle.id;
    if (circleId) {
      this.props.getOshikatsuData({ circleId }); 
    }
  }

  render() {
    const { servicesCircles, circlesRelations, circleList } = this.props;
    if (!servicesCircles) {
      return <div>ロード中...</div>;
    }
    const serviceIdNum = Number(this.props.selectedServiceIds[0]);
    const relatedCircleIds = servicesCircles
      .filter((sc) => sc.service_id === serviceIdNum)
      .map((sc) => sc.circle_id);
    const allChildIds = new Set();
    circlesRelations.forEach((rel) => {
      if (!rel.is_deleted) {
        allChildIds.add(rel.child_circle_id);
      }
    });
  
    const circleMap = {};
    circleList.forEach((c) => {
      circleMap[c.id] = c;
    });

    const corporateCircleIds = relatedCircleIds.filter((cid) => {
      const cData = circleMap[cid];
      if (!cData) return false;
      if (cData.is_company_owned !== true) return false;
      if (cid < 100001 || cid > 110000) return false;
      return true;
    });
    // const otherCircleIds = relatedCircleIds.filter((cid) => {
    //   const cData = circleMap[cid];
    //   if (!cData) return false;
    //   const isChild = allChildIds.has(cid);
    //   return cData.is_company_owned === false && !isChild;
    // });

    const parentMap = {};
    circlesRelations.forEach((rel) => {
      if (!rel.is_deleted) {
        if (!parentMap[rel.parent_circle_id]) {
          parentMap[rel.parent_circle_id] = [];
        }
        parentMap[rel.parent_circle_id].push(rel.child_circle_id);
      }
    });

    // 全般系のサークルを先頭に表示させる
    const general = corporateCircleIds.filter((cid) => cid >= 103797 && cid <= 103822);
    const normal = corporateCircleIds.filter((cid) => cid < 103797 || cid > 103822);
    const sortedCorporateCircleIds = [...general, ...normal];
    const corporateCards = sortedCorporateCircleIds.map((cid) => {
      const cData = circleMap[cid];
      if (!cData) return null;
      const isSelected = this.props.parentCircleId === cid;
      return (
        <div className="col-sm-6 col-md-4 mb-3 d-flex align-items-stretch" key={cid}>
          <div
            className="card shadow-sm w-100"
            style={{
              cursor: 'pointer',
              border: isSelected ? '2px solid #FF6467' : '1px solid #ddd',
              transition: 'all 0.2s ease',
              height: '140px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
            onClick={() => this.onClickParentCircle(cid)}
          >
            <div className="card-body d-flex flex-column justify-content-center text-center p-2">
              <h6 className="card-title mb-1">{cData.name}</h6>
            </div>
          </div>
        </div>
      );
    });

    // const otherCards = otherCircleIds.map((cid) => {
    //   const cData = circleMap[cid];
    //   if (!cData) return null;
    //   return (
    //     <div className="col-sm-6 col-md-4 mb-3 d-flex align-items-stretch" key={cid}>
    //       <div
    //         className="card shadow-sm w-100"
    //         style={{
    //           cursor: 'pointer',
    //           border: '1px solid #ddd',
    //           transition: 'all 0.2s ease',
    //           height: '140px',
    //           display: 'flex',
    //           flexDirection: 'column',
    //           justifyContent: 'center',
    //         }}
    //         onClick={() => this.onClickParentCircle(cid)}
    //       >
    //         <div className="card-body d-flex flex-column justify-content-center text-center p-2">
    //           <h6 className="card-title mb-1">{cData.name}</h6>
    //         </div>
    //       </div>
    //     </div>
    //   );
    // });

    let modalContent = null;
    if (this.state.openCircleIdForModal) {
      const parentId = this.state.openCircleIdForModal;
      const parentData = circleMap[parentId];
      if (parentData) {
        const childIds = parentMap[parentId] || [];
        const displayIds = [parentId, ...childIds];
        const childCards = displayIds.map((cId) => {
          const cData = circleMap[cId];
          if (!cData) return null;
          const selected = String(this.state.selectedCircleId) === String(cId);
          return (
            <div className="col-6 col-md-3 mb-3" key={cId}>
              <div
                className="card shadow-sm"
                style={{
                  cursor: 'pointer',
                  border: selected ? '2px solid #FF6467' : '1px solid #ddd',
                  transition: 'all 0.2s ease-in-out',
                  height: '185px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
                onClick={() => this.selectChildCircle(cId)}
              >
                {cData.main_image_url ? (
                  <div style={{ height: '130px', overflow: 'hidden' }}>
                    <img
                      src={cData.main_image_url}
                      alt="サークル画像"
                      style={{ objectFit: 'cover', height: '100%', width: '100%' }}
                    />
                  </div>
                ) : (
                  <div style={{ height: '100px', backgroundColor: '#eee' }} />
                )}
                <div className="card-body d-flex flex-column justify-content-center text-center p-2">
                  <h6 className="card-title mb-1">{cData.name}</h6>
                </div>
              </div>
            </div>
          );
        });
        modalContent = (
          <div>
            <p className="text-fz-16px text-black-333 mb-2">
              「{parentData.name}」とその関連サークルに紐づけできます。
            </p>
            <div className="row">{childCards}</div>
          </div>
        );
      }
    }
    
    return (
      <div
        className="bg-gray h-100 pt-3 min-vh-100 position-relative"
        style={{ paddingBottom: this.props.isApp === false ? '168px' : '112px' }}
      >
        <div className="container col-md-8 col-lg-6">
          <h3 className="font-weight-bold text-black-333 mt-3 mb-2">
            既存のサークルと関連付ける
          </h3>
          <p className="text-fz-small text-black-50">
            「推し活」サークルに紐づくサークルを選択できます。<br/>
            既存のサークルと関連付けることで、サークルの趣旨がわかりやすくなったり、人を集めやすくなったりします。
            <br/>
            関連付けたいサークルを1つ、選択してください。
          </p>
        </div>

        <div className="container col-md-8 col-lg-6">
          <div className="d-flex justify-content-between align-items-center mb-2 mt-3">
            <h4 className="text-fz-16px text-black-333 mb-0">
              公式サークル一覧
            </h4>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={this.handleClickLater}
            >
              あとで
            </button>
          </div>
          {corporateCards.length === 0 ? (
            <p className="text-muted">子サークルを持つ企業サークルはありません。</p>
          ) : (
            <div className="row">{corporateCards}</div>
          )}

          {/* {otherCards.length > 0 && (
            <div>
              <hr />
              <h4 className="text-fz-16px text-black-333 mb-2">
                一般サークル一覧
              </h4>
              <div className="row">{otherCards}</div>
            </div>
          )} */}
        </div>

        <div className="fixed-bottom" style={{ paddingBottom: '8px' }}>
          <div className="container col-md-8 col-lg-6">
            <div
              className="row"
              style={{ marginBottom: this.props.isApp === true ? '24px' : '' }}
            >
              <div className="col">
                <button
                  type="button"
                  className={`col-6 mr-2 a-button a-button__top a-button__top--outline w-100 ${
                    this.props.isApp === false ? 'mb-2' : ''
                  }`}
                  onClick={this.onClickBack}
                  value="1"
                >
                  戻る
                </button>
              </div>
              <div className="col">
                <button
                  type="button"
                  className={`col-6 a-button a-button__top a-button--orange mr-2 w-100 ${
                    this.props.isApp === false ? 'mb-2' : ''
                  }`}
                  onClick={this.onClickNext}
                >
                  次へ
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* モーダル */}
        {this.state.openCircleIdForModal && (
          <div
            className="modal d-block"
            role="dialog"
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">サークル関連づけ</h5>
                  <button type="button" className="close" onClick={this.closeModal}>
                    <span>×</span>
                  </button>
                </div>
                <div className="modal-body mx-3"
                  style={{ maxHeight: '70vh', overflowY: 'auto' }}
                >
                  {modalContent || <p>サークル情報を取得できませんでした。</p>}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                    閉じる
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  ...state,
  isApp: ownProps.isApp,
  type: ownProps.type,
  servicesCircles: state.servicesCircles,
  circlesRelations: state.circlesRelations,
  circleList: state.circleList,
  circle: state.circle,
  selectedServiceIds: state.selectedGenres,
  parentCircleId: state.parentCircleId,
}};

const mapDispatchToProps = (dispatch) => ({
  changePage: (pageNum) => {
    dispatch(Module.actions.changePage({ pageNum }));
  },
  createOshikatsuGenre: (circleId, serviceIds) => {
    dispatch(Module.actions.createOshikatsuGenre({ circleId, service: serviceIds }));
  },
  updateCircle: (circle, isSubmit = false) => {
    dispatch(Module.actions.updateCircle({ circle, isSubmit }));
  },
  createRelation: (payload) => {
    dispatch(Module.actions.createRelation(payload));
  },
  getOshikatsuData: (payload) => dispatch(Module.actions.getOshikatsuData(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormOshikatsuCirclesPage);